import { contract } from '@repo/api/contract';
import { initTsrReactQuery } from '@ts-rest/react-query/v5';
import { ApiFetcherArgs, tsRestFetchApi } from '@ts-rest/core';
import apiEnvironment from '@/data/environment';
import { useBullhornSessionContext } from '@/api/BullhornSession';
import { useMemo } from 'react';

export { contract };
export type { ClientInferResponseBody, ClientInferRequest } from '@repo/api/contract';
export type TsrContract = typeof contract;

const tsrOptions = {
  baseUrl: apiEnvironment.baseUrl,
  jsonQuery: true,
  baseHeaders: {
    'Toro-Is-Embedded': '' as string,
  },
  api: async (params: ApiFetcherArgs) => {
    return tsRestFetchApi(params);
  },
} as const satisfies Parameters<typeof initTsrReactQuery>[1];

const tsr = initTsrReactQuery(contract, tsrOptions);

// Kept for backwards compatibility with the one usage in `auth.ts`
// Ideally should not be used anywhere else
export const baseTsr = tsr;

// Export the adminApi client for use in the accountService
export const adminApiClient = tsr.adminApi;

// Hook to get a TSR instance with access to the embedded session token, if needed
export function useTsr(): typeof tsr {
  const bullhornSession = useBullhornSessionContext()?.session ?? null;
  return useMemo(() => {
    let tsrInstance = tsr;
    if (bullhornSession?.sessionToken) {
      tsrInstance = initTsrReactQuery(contract, {
        ...tsrOptions,
        baseHeaders: {
          ...tsrOptions.baseHeaders,
          Authorization: `Bearer ${bullhornSession.sessionToken}`,
          'Toro-Is-Embedded': 'true',
        },
      });
      // } else {
      //     tsrInstance = initTsrReactQuery(contract, {
      //         ...tsrOptions,
      //         baseHeaders: {
      //             ...tsrOptions.baseHeaders,
      //             'toro-is-embedded': 'false'
      //         },
      //     });
    }
    return tsrInstance;
  }, [bullhornSession]);
}
